const colorRange = require('./lightBlueToDarkBlueColorRange');

const thisColorRange = {};

thisColorRange.computeColor = function(factorFromStart) {
  return colorRange.computeColor(factorFromStart);
};

module.exports = thisColorRange;
